const t = {}

t.loading = '加载中...';
t.remind = '提示';
t.error = '错误';
t.back = '返回'
t.next = '下一步'
t.submit = '提交'

t.trade = {}
t.trade.subFor = '认购'
t.trade.sub = '申购'
t.trade.fixed = '定投'
t.trade.subTitle = '基金买入'
t.trade.bonusTitle = '修改分红方式'
t.trade.cancleTitle = '撤单'
t.trade.redeTitle = '基金赎回'
t.trade.transTitle = '基金转换'

export default t
